module.exports = __webpack_public_path__ + "img/meds-icon-2.094d7d25.svg";